/**
 * @generated SignedSource<<130259d307d50f47c1e43755a701aa6f>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type sbSharedAppliedFiltersHelpersCount_appliedFilter$data = {
  readonly name: string | null;
  readonly values: ReadonlyArray<{
    readonly __typename: "SearchBrowseParsedParamValue";
  } | null> | null;
  readonly " $fragmentType": "sbSharedAppliedFiltersHelpersCount_appliedFilter";
};
export type sbSharedAppliedFiltersHelpersCount_appliedFilter$key = {
  readonly " $data"?: sbSharedAppliedFiltersHelpersCount_appliedFilter$data;
  readonly " $fragmentSpreads": FragmentRefs<"sbSharedAppliedFiltersHelpersCount_appliedFilter">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "sbSharedAppliedFiltersHelpersCount_appliedFilter"
};

(node as any).hash = "76ef0e55d4c611d3c995e2141c342c8b";

export default node;
